import React from "react";
import { Portfolio } from "../../../../../graphql/generated";
import ContactBox from "./comps/ContactBox";
import MapBox from "./comps/MapBox";
import { map } from "./constants";
import { ContactContainer } from "./styled";

interface Props {
  portfolioData: Omit<Portfolio, "createdBy">;
}

const ContactSection: React.FC<Props> = ({ portfolioData }) => {
  const mapObj = portfolioData.map
    ? {
        accessToken: process.env.REACT_APP_MAP_ACCESS_TOKEN || "",
        style: process.env.REACT_APP_MAP_STYLE || "",
        coordinates: [
          +portfolioData.map.longitude,
          +portfolioData.map.latitude,
        ],
      }
    : map;

  return (
    <ContactContainer>
      <div>
        <ContactBox />
      </div>
      <div>
        <MapBox map={mapObj} />
      </div>
    </ContactContainer>
  );
};

export default ContactSection;
